// main
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Slider from "react-slick";

import WebbDividerMedium from "../webx/webb-divider-md"
import WebbSpinner from "../webx/webb-spinner";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { CollectionsList } from "../../services/srvc-store-realm";

import { Row, Col, Space, Typography } from 'antd';
const { Paragraph } = Typography;

const list = require('../../data/data-collections-list.json').data

export default function StoreListModule () {
  
  const usxx = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();

  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState()
  
  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        const result = await CollectionsList({
          data: {user: asset.usid},
          user: asset.usid
        })
        console.log (result)
        setData(result.data.store)
        // setSort([...new Set(result.map(item=>item.meta.form))])

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: list.length > 6 ? 6 : list.length,
    slidesToScroll: list.length > 6 ? 6 : list.length,
    responsive: [
      {
        breakpoint: 600,
        settings: { slidesToShow: 4, slidesToScroll: 4 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 3, slidesToScroll: 3 }
      }
    ]
  };

  if (loading) return <WebbSpinner />

  return (
  <>
    <div className="d-none">
      <Row justify="space-between" align="middle">
        <Col span={21}>
          <Row justify="start" align="middle">
            <Col flex="auto" className="">
              <h3 className='m-0'>Collections</h3>
              <h4 className='m-0 text-color-tone'>Total: {loading ? 0 :data.length}</h4>
            </Col>
          </Row>
        </Col>

        <Col span={3} className="py-1 text-end" >
          <Space direction="horizontal" 
            style={{width: '100%', justifyContent: 'right'}}>
            <Row justify="center" align="middle"
              className={`text-center back-color-lite hirich cursor`}
              style={{width:'3.3rem', height:'3.3rem', borderRadius:'50%'}}
              onClick={() => history.push(`/${usxx}/collections/create`)}
              ><i className={`bx bx-plus`}></i>
            </Row>
          </Space>
        
        </Col>
      </Row>
    </div>

    <WebbDividerMedium/>
    <div className={loading ? '': 'd-none'}>
      <WebbSpinner />
    </div>
    <div className={data.length ===0 ? '': 'd-none'}>
      <p className="text-center text-color-tone">No Collections</p>
    </div>

    <div className={loading ? 'd-none': ''}>
      <Slider {...settings}>
      {data && data.map((item, i) => (
        <div className="p-1" key={i}>
          <Link to={`/${usxx}/cx/v/${item.store}`}>
            <div className="border media-square rounded-xx hirich cursor">
              <img className="p-1 rounded-xx" src={item.link} alt={item.memo}></img>
            </div>
            <div className="text-center mt-1">
              <Paragraph ellipsis={{rows:1, suffix: ''}} className="text-bold text-color-tone">{item.name}</Paragraph>
            </div>
          </Link>
        </div>

      ))}
      </Slider>
    </div>




    <WebbDividerMedium/>

  </>
  )
}